module.exports = __webpack_public_path__ + "assets/40a0c066644f213f6a32b021362fcabe.png";